import { fetchState } from '@/store/extensions/fetch';
import { updateState } from '@/store/extensions/update';
import { createState } from '@/store/extensions/create';
import { deleteState } from '@/store/extensions/delete';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  ...fetchState,
  ...createState,
  ...updateState,
  ...deleteState,

  currentUser: null,
  context: null,
  authenticating: false,
  validating: false,
  registering: false,
  loggingOutCurrentUser: false,
  processing: false,
  formModalOpened: false,
  formModalContext: null,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js